import Link from 'Component/Link';
import TextPlaceholder from 'Component/TextPlaceholder';
import {
    Breadcrumb as SourceBreadcrumb
} from 'SourceComponent/Breadcrumb/Breadcrumb.component';

import './Breadcrumb.override.style';

/** @namespace PeggysagePwa/Component/Breadcrumb/Component */
export class BreadcrumbComponent extends SourceBreadcrumb {
    /**
     * Override: change separator (replace chevron by slash), return span instead of link if no url
     * @returns {JSX.Element}
     */
    renderLink() {
        const {
            index,
            isDisabled,
            name
        } = this.props;

        const url = this.getLinkUrl() || {};
        const nameToString = String(name);

        if (!url?.pathname || url?.pathname === '') {
            return (
                <span
                  block="Breadcrumb"
                  elem="Link"
                  tabIndex="-1"
                >
                    <span block="Breadcrumb" elem="Link-Name" itemProp="name">
                        <TextPlaceholder content={ nameToString } />
                    </span>
                    <span block="Breadcrumb" elem="Separator">/</span>
                    <meta itemProp="position" content={ index } />
                </span>
            );
        }

        return (
            <Link
              block="Breadcrumb"
              elem="Link"
              to={ url }
              tabIndex={ isDisabled ? '-1' : '0' }
            >
                <meta itemProp="item" content={ window.location.origin + url.pathname } />
                <span block="Breadcrumb" elem="Link-Name" itemProp="name">
                    <TextPlaceholder content={ nameToString } />
                </span>
                <span block="Breadcrumb" elem="Separator">/</span>
                <meta itemProp="position" content={ index } />
            </Link>
        );
    }

    /**
     * Override: add loading class
     * @return {JSX.Element}
     */
    render() {
        const { index, name } = this.props;

        const nameToString = String(name);

        return (
            <li
              block="Breadcrumb"
              key={ index }
              itemProp="itemListElement"
              itemScope
              itemType="http://schema.org/ListItem"
              mods={ { isLoading: !nameToString } }
            >
                { this.renderLink() }
            </li>
        );
    }
}

export default BreadcrumbComponent;
